<template>
  <div>
    <InningTournamentModal />
    <TournamentAddGameModal :tournamentData="tournamentData" :association_id="association_id" />
    <TournamentEditGameModal :tournamentData="tournamentData" :association_id="association_id" />
    <div class="overflow-auto" v-if="filteredGames.length > 0">

      <div v-for="(game, start_date) in groupedFilteredGames" :key="start_date">
        <h2 class="date-heading">{{ formatDate(start_date) }}</h2>
        <div class="row m-0" v-if="game.length > 0">
          <div v-for="gameItem in game" :key="gameItem.id" class="col-12 col-md-6 col-xl-4 p-0">
            <div class="game-detail-wrapper single-event-side-game" @click="callBoxViewModal(gameItem)">
              <div class="game-content">
                <div class="live-inner-top">
                  <div class="d-flex align-items-center" style="gap: 5px">
                    <div class="live-delayed-sec"
                      v-if="gameItem.game_delayed == 1 && gameItem.game_live == 1 && gameItem.status == 1">
                      <span class="delayed-tag">Delayed</span>
                      <div class="video-icon">
                        <img src="../../assets/Svg/delayed.svg" alt="delayed" />
                      </div>
                    </div>
                    <div class="live-delayed-sec"
                      v-if="gameItem.game_delayed == 0 && gameItem.game_live == 1 && gameItem.status == 1">
                      <span class="delayed-tag live-tag">Live</span>
                      <div class="video-icon">
                        <!-- <img src="../../assets/Svg/video.svg" alt="live" /> -->
                      </div>
                    </div>
                    <span class="game-name">{{ gameItem.game_name }}</span>
                  </div>
                  <div class="right-part-sec">
                    <div v-if="
                      gameItem.status == 1 &&
                      gameItem.game_scores &&
                      gameItem.game_scores.length > 0
                    " class="live-count">
                      {{ gameItem.game_scores[0].end_inning_flag }}
                    </div>
                    <div class="final-count" v-if="gameItem.status == 2">
                      <span>F</span>
                    </div>
                    <div @click.stop="handleActionClick(gameItem)" class="d-flex justify-content-end">
                      <TournamentEllipsis v-if="
                        currentIsAdmin == '1' || gameItem.umpire_id == UserId
                      " :clickedGame="gameItem" :currentIsAdmin="currentIsAdmin" :currentIsUmpire="currentIsUmpire"
                        :association_id="association_id" ref="ellipsisDropdown" />
                    </div>
                  </div>
                </div>
                <div class="date-content">
                  <p>{{ formatDate(start_date) }} - {{ gameItem.start_time }}</p>
                </div>

                <div class="team-opponent-score-wrap">
                  <div>
                    <div class="d-flex align-items-center flex-row pb-1">
                      <div class="opponent-name" v-if="
                        gameItem.game_scores?.some((team) => team?.team_type === 1)
                      ">
                        <div class="custom-avatar" v-if="gameItem.game_scores?.find(team => team?.team_type === 1)?.team?.team_avatar == null" 
                          :style="{ backgroundColor: getRandomColor() }">
                          {{ getInitials(gameItem.game_scores?.find(team => team?.team_type === 1)?.team?.team_name) }}
                        </div>
                        <div class="team-image" v-else>
                          <div class="users-notification" v-if="imgLoader == 1">
                            <img src="../../assets/loader.gif" alt="" />
                          </div>
                          <img @load="onImageLoad" v-if="gameItem.game_scores?.find(
                            (team) => team?.team_type === 1
                          )?.team?.team_avatar == null" :src="team_image" alt="" />
                          <img @load="onImageLoad" v-if="gameItem.game_scores?.find(
                            (team) => team?.team_type === 1
                          )?.team?.team_avatar != null" :src="url + gameItem.game_scores?.find(
                            (team) => team?.team_type === 1
                          )?.team?.team_avatar" alt="" />
                        </div>
                        <h6 class="teams-name-sec" :class="{
                          'winner-text': gameItem.status === 2 && 
                            calculateGameScores(gameItem).visitRuns > calculateGameScores(gameItem).homeRuns,
                           'loser-text': gameItem.status === 2 && 
                            calculateGameScores(gameItem).visitRuns < calculateGameScores(gameItem).homeRuns, 
                        }">
                          #{{
                            gameItem.game_scores?.find(
                              (team) => team?.team_type === 1
                            )?.teams?.team_sr_no
                          }}:
                          {{
                            gameItem.game_scores?.find(
                              (team) => team?.team_type === 1
                            )?.team?.team_name
                          }}
                        </h6>
                      </div>
                      <div class="opponent-name" v-else>
                        <div class="custom-avatar" v-if="!gameItem?.team_one?.team_data?.team_avatar" 
                          :style="{ backgroundColor: getRandomColor() }">
                          {{ getInitials(gameItem?.team_one?.team_data?.team_name) }}
                        </div>
                        <div class="team-image" v-else>
                          <div class="users-notification" v-if="imgLoader == 1">
                            <!-- <div class="lds-dual-ring-refresh"></div> -->
                            <img src="../../assets/loader.gif" alt="" />
                          </div>
                          <img @load="onImageLoad" v-if="gameItem?.team_one && gameItem?.team_one?.team_data?.team_avatar"
                            :src="url + gameItem.team_one?.team_data?.team_avatar" alt="" />
                          <img @load="onImageLoad" v-else alt="" :src="team_image" />
                        </div>
                        <div class="teams-name-sec">
                          {{ gameItem?.team_one && gameItem?.team_one?.team_data && gameItem?.team_one?.team_data?.team_name
                            ? `#${gameItem?.team_one?.team_sr_no}: ${gameItem?.team_one?.team_data?.team_name}` : 'TBD' }}
                        </div>
                      </div>
                    </div>

                    <div class="d-flex align-items-center flex-row pb-1">
                      <div class="opponent-name" v-if="
                        gameItem.game_scores?.some((team) => team?.team_type === 2)
                      ">
                        <div class="custom-avatar" v-if="gameItem.game_scores?.find(team => team?.team_type === 2)?.team?.team_avatar == null" 
                          :style="{ backgroundColor: getRandomColor() }">
                          {{ getInitials(gameItem?.game_scores?.find(team => team?.team_type === 2)?.team?.team_name) }}
                        </div>
                        <div class="team-image" v-else>
                          <div class="users-notification" v-if="imgLoader == 1">
                            <img src="../../assets/loader.gif" alt="" />
                          </div>
                          <img @load="onImageLoad" v-if="gameItem?.game_scores?.find(
                            (team) => team?.team_type === 2
                          )?.team?.team_avatar == null" :src="team_image" alt="" />
                          <img @load="onImageLoad" v-if="gameItem.game_scores?.find(
                            (team) => team?.team_type === 2
                          )?.team?.team_avatar != null" :src="url + gameItem?.game_scores?.find(
                            (team) => team?.team_type === 2
                          )?.team?.team_avatar" alt="" />
                        </div>
                        <h6 class="teams-name-sec"  :class="{
                          'winner-text': gameItem.status === 2 && 
                            calculateGameScores(gameItem).homeRuns > calculateGameScores(gameItem).visitRuns,
                            'loser-text': gameItem.status === 2 && 
                            calculateGameScores(gameItem).homeRuns < calculateGameScores(gameItem).visitRuns,
                        }">
                          #{{
                            gameItem.game_scores?.find(
                              (team) => team?.team_type === 2
                            )?.teams?.team_sr_no
                          }}:
                          {{
                            gameItem.game_scores?.find(
                              (team) => team?.team_type === 2
                            )?.team?.team_name
                          }}
                        </h6>
                      </div>
                      <div class="opponent-name" v-else>
                        <div class="custom-avatar" v-if="!gameItem?.team_two?.team_data?.team_avatar" 
                          :style="{ backgroundColor: getRandomColor() }">
                          {{ getInitials(gameItem.team_two?.team_data?.team_name) }}
                        </div>
                        <div class="team-image" v-else>
                          <div class="users-notification" v-if="imgLoader == 1">
                            <!-- <div class="lds-dual-ring-refresh"></div> -->
                            <img src="../../assets/loader.gif" alt="" />
                          </div>
                          <img @load="onImageLoad" v-if="gameItem?.team_two && gameItem?.team_two?.team_data?.team_avatar"
                            :src="url + gameItem?.team_two?.team_data?.team_avatar" alt="" />
                          <img @load="onImageLoad" v-else alt="" :src="team_image" />
                        </div>
                        <div class="teams-name-sec">
                          {{ gameItem.team_two && gameItem?.team_two?.team_data && gameItem.team_two?.team_data?.team_name
                            ? `#${gameItem?.team_two?.team_sr_no}: ${gameItem.team_two?.team_data?.team_name}` : 'TBD' }}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="played-data text-right">
                    <div
                      v-if="calculateGameScores(gameItem).homeRuns != 0 || calculateGameScores(gameItem).visitRuns != 0">
                      <p class="tie flex-row align-items-center" style="gap: 5px">
                        <span
                          :class="{
                            'fw-600': gameItem.status === 2 && calculateGameScores(gameItem).visitRuns > calculateGameScores(gameItem).homeRuns,
                            'loser-text': gameItem.status === 2 && calculateGameScores(gameItem).visitRuns < calculateGameScores(gameItem).homeRuns
                          }"
                        >
                          {{ calculateGameScores(gameItem).visitRuns }}
                        </span>
                        <img :src="arrow_left" class="arrow-image" alt="arrow-left" v-if="
                          gameItem.status === 1 &&
                          gameItem.game_scores &&
                          gameItem.game_scores?.find(
                            (team) => team?.team_type == 1 && team?.batting_flag == 1
                          )
                        " />
                        <img :src="cup" alt="cup"
                          v-if="gameItem.status === 2 && calculateGameScores(gameItem).visitRuns > calculateGameScores(gameItem).homeRuns" />
                      </p>
                      <p class="win-data-two flex-row align-items-center" style="gap: 5px">
                        <span
                          :class="{
                            'fw-600': gameItem.status === 2 && calculateGameScores(gameItem).homeRuns > calculateGameScores(gameItem).visitRuns,
                            'loser-text': gameItem.status === 2 && calculateGameScores(gameItem).homeRuns < calculateGameScores(gameItem).visitRuns
                          }"
                        >
                          {{ calculateGameScores(gameItem).homeRuns }}
                        </span>
                        <img :src="arrow_left" class="arrow-image" alt="arrow-left" v-if="
                          gameItem.status === 1 &&
                          gameItem.game_scores &&
                          gameItem.game_scores?.find(
                            (team) => team?.team_type == 2 && team?.batting_flag == 1
                          )
                        " />
                        <img :src="cup" alt="cup"
                          v-if="gameItem.status === 2 && calculateGameScores(gameItem).homeRuns > calculateGameScores(gameItem).visitRuns" />
                      </p>
                    </div>

                    <p class="not-started"
                      v-if="gameItem.game_live == 0 && gameItem.status != 2 && calculateGameScores(gameItem).homeRuns == 0 && calculateGameScores(gameItem).visitRuns == 0">
                      Game yet to begin
                    </p>
                  </div>
                </div>

                <span class="game-location cursor-pointer" @click="openGoogleMapforGamePark(gameItem, $event)" v-if="
                  gameItem.park_name != null ||
                  gameItem.park_name != '' ||
                  gameItem?.field?.field_name != null ||
                  gameItem?.field?.field_name != ''
                ">
                  <img src="../../assets/Svg/maximize.svg" class="mr-2" />
                  <p>{{ gameItem?.field?.field_name }} <span v-if="gameItem?.field?.field_name">-</span> {{
                    gameItem?.park?.park_name }}
                  </p>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="no-event-wrap h-100" v-if="
      (!filteredGames || filteredGames.length === 0) && showLoader === 0
    ">
      <img src="../../assets/Svg/no-data.svg" alt />
      <p class="header">No boxscores found.</p>
      <p class="info">
        All box scores for this division will appear here. Broaden your search by tweaking the filters above.
      </p>
    </div>

    <div class="products-list-shim p-0 mt-3" v-if="showLoader == 1">
      <content-placeholders :rounded="true">
        <content-placeholders-img />
        <content-placeholders-heading />
      </content-placeholders>
      <content-placeholders class="mt-3" :rounded="true">
        <content-placeholders-img />
        <content-placeholders-heading />
      </content-placeholders>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import TournamentAddGameModal from "./Modals/TournamentAddGameModal.vue";
import TournamentEditGameModal from "../Tournaments/Modals/TournamentEditGameModal.vue";
import TournamentEllipsis from "./Modals/TournamentTeamActionModal.vue";
import InningTournamentModal from "./InningTournamentModal.vue";

export default {
  name: "TournamentGames",
  components: {
    TournamentAddGameModal,
    TournamentEditGameModal,
    TournamentEllipsis,
    InningTournamentModal
  },
  data() {
    return {
      url: this.$groupAvatarStorageURL,
      imgLoader: 1,
      clickedGame: [],
      showLoader: 1,
      UserId: localStorage.getItem("userId"),
      tournamentGame: [],
      tournament_guid: "",
      filteredGames: [],
      selectedFilter: localStorage.getItem("gameFilter") || "all", // Default filter
      arrow_left: require("../../assets/Svg/arrow-left.svg"),
      cup: require("../../assets/Svg/cup.svg"),
      team_image: require("../../assets/Svg/people.svg"),
      selectedTeamsForFilter: [],
      allGames: []
    };
  },
  props: {
    tournamentData: {
      typeof: Object,
    },
    currentIsUmpire: {
      type: String,
    },
    currentIsAdmin: {
      type: String,
    },
    association_id: {
      type: Number,
    },
  },
  computed: {
    filteredGamesByTeams() {
      if (!this.selectedTeamsForFilter || this.selectedTeamsForFilter.length === 0) {
        return this.tournamentGame;
      }

      return this.tournamentGame.filter(game => {
        // Check if either team in the game matches any selected team
        const teamOneName = game.team_one?.team_data?.team_name;
        const teamTwoName = game.team_two?.team_data?.team_name;

        return this.selectedTeamsForFilter.some(selectedTeam =>
          selectedTeam === teamOneName || selectedTeam === teamTwoName
        );
      });
    },
    groupedFilteredGames() {
      const grouped = {};
      this.filteredGames.forEach((game) => {
        const startDate = game.start_date;
        if (!grouped[startDate]) {
          grouped[startDate] = [];
        }
        grouped[startDate].push(game);
      });

      // Sort the games within each date group by start_time
      Object.keys(grouped).forEach((key) => {
        grouped[key].sort((a, b) => {
          const dateA = new Date(`2000-01-01 ${a.start_time}`);
          const dateB = new Date(`2000-01-01 ${b.start_time}`);
          return dateA - dateB;
        });
      });

      // Sort date groups in ascending order
      const sortedGrouped = {};
      Object.keys(grouped)
        .sort((a, b) => new Date(a) - new Date(b))
        .forEach((key) => {
          sortedGrouped[key] = grouped[key];
        });

      return sortedGrouped;
    }

  },
  methods: {
    onImageLoad() {
      this.imgLoader = 0;
    },
    getInitials(name) {
      return name ? name.charAt(0).toUpperCase() : "?";
    },
    // Add this method to your methods section
    calculateGameScores(gameItem) {
      if (!gameItem.game_scores || gameItem.game_scores.length === 0) {
        return { homeRuns: 0, visitRuns: 0 };
      }

      let homeRuns = 0;
      let visitRuns = 0;

      // Process each team's scores
      gameItem.game_scores.forEach((gameS) => {
        if (gameS.team_type === 1) { // Visiting team
          gameS.game_innings.forEach((inning) => {
            if (inning.inning_type === 2 && inning.score !== null) { // Only count runs (inning_type 2)
              visitRuns += parseInt(inning.score);
            }
          });
        } else if (gameS.team_type === 2) { // Home team
          gameS.game_innings.forEach((inning) => {
            if (inning.inning_type === 2 && inning.score !== null) { // Only count runs (inning_type 2)
              homeRuns += parseInt(inning.score);
            }
          });
        }
      });

      return { homeRuns, visitRuns };
    },
    callBoxViewModal(score) {
      if (score.game_scores.length != 0) {
        this.$root.$emit("openBoxViewScoresModal", score);
        this.$root.$emit("openBoxViewInningModal", score);
      }
    },
    getRandomColor() {
      const colors = [
        "#FCE4EC",
        "#E3F2FD",
        "#F1F8E9",
        "#FFF8E1",
        "#EDE7F6",
        "#FFEBEE",
        "#F9FBE7",
        "#FFF3E0",
        "#ECEFF1",
        "#FFECB3",
      ];
      return colors[Math.floor(Math.random() * colors.length)];
    },
    openGoogleMapforGamePark(item, event) {
      event.preventDefault(); // Prevents <router-link> navigation
      event.stopPropagation();
      const strlatLng = item["park_lat"] + "," + item["park_lng"];
      const urlSuffix = strlatLng ? strlatLng : item["park_address"];
      window.open(
        "https://www.google.com/maps/search/?api=1&query=" + urlSuffix,
        "_blank"
      );
    },
    handleActionClick(data) {

      this.clickedGame = data;
    },
    callModal() {
      this.$root.$emit("openTournamentAddGameModal");
    },
    formatDate(dateString) {
      const date = new Date(dateString + 'T00:00:00'); // Prevents timezone shift

      if (isNaN(date)) {
        return "";
      }

      const weekdays = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
      const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
        "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

      const weekday = weekdays[date.getDay()];
      const month = months[date.getMonth()];
      const day = date.getDate();
      const year = date.getFullYear();

      return `${weekday} ${month} ${day}, ${year}`;
    },

    async getTournamentGame() {
      this.showLoader = 1;
      try {
        const response = await axios.post(
          `${process.env.VUE_APP_API_URL}tournaments/getTournamentGames`,
          { tournament_guid: this.tournament_guid ? this.tournament_guid : this.tournamentData[0].guid });

        if (response.data.statusCode === 200) {
          this.allGames = response.data.data; // Store all games
          this.applyFilters();
          this.showLoader = 0;
        }
        //  else if (response.data.statusCode === 404) {
        //   this.$alert(response.data.message, 'Error');
        //   this.$router.push({ name: "Teams" });
        //   this.showLoader = 0;
        // }
        //  else if (response.data.statusCode === 404) {
        //   this.$router.push({ name: "PageNotFound" });
        //   this.showLoader = 0;
        // }
        else {
          this.errorMessage = response.data.message || "Unknown error occurred";
          this.showLoader = 0;
        }
      } catch (error) {
        this.errorMessage = "Failed to fetch data";
        this.showLoader = 0;
      } finally {
        this.showLoader = 0;
      }
    },
    applyFilters() {
      // First filter by teams if any are selected
      let filtered = this.allGames;

      if (this.selectedTeamsForFilter.length > 0) {
        filtered = this.allGames.filter(game => {
          const teamOneName = game.team_one?.team_data?.team_name;
          const teamTwoName = game.team_two?.team_data?.team_name;

          return this.selectedTeamsForFilter.some(selectedTeam =>
            selectedTeam === teamOneName || selectedTeam === teamTwoName
          );
        });
      }

      // Then apply the status filter
      if (this.currentStatusFilter === "ongoing") {
        filtered = filtered.filter(game => game.game_live == 1 && game.status !== 2);
      } else if (this.currentStatusFilter === "final") {
        filtered = filtered.filter(game => game.status == 2);
      }

      this.filteredGames = filtered;
    },

    // Update the filterGames method to just handle status filtering
    filterGames(filter) {
      this.currentStatusFilter = filter;
      localStorage.setItem('gameFilter', filter);
      this.applyFilters();
    },
  },
  mounted() {
    const storedTournamentID = localStorage.getItem("tournamentID");
    if (storedTournamentID) {
      this.tournament_guid = storedTournamentID;
    }

    this.getTournamentGame();

    this.$root.$on("RefreshTournamentGames", () => {
      this.filteredGames = [];
      this.getTournamentGame();
    });

    this.$root.$on("showTournamentForSwitch", () => {
      this.filteredGames = [];
      this.getTournamentGame();
    });


    this.$root.$on("changeDivision", (tournamentID) => {
      this.tournament_guid = tournamentID;
      localStorage.setItem("tournamentID", tournamentID); // Save to localStorage

      // Always ensure selectedFilter has a value before calling the API
      if (!this.selectedFilter) {
        this.selectedFilter = localStorage.getItem("gameFilter") || "all"; // or "ongoing" / "final" — whatever your default is
      }

      this.filteredGames = [];
      this.getTournamentGame();
    });

    this.$root.$on("FilterGames", (selectedFilter) => {
      this.filterGames(selectedFilter)
    });

    this.$root.$on("filterGamesByTeams", (selectedTeams) => {
      this.selectedTeamsForFilter = selectedTeams;
      this.applyFilters();
    });
  },
};
</script>